import { ChevronRight, FileText } from "lucide-react";
import { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/Dialog";
import { UserAgreement } from "@/pages/UserAgreement";
import { PrivacyAgreement } from "@/pages/PrivacyAgreement";

// 服务协议列表组件
export function ServiceAgreementList() {
  const [showAgreementDialog, setShowAgreementDialog] = useState(false);
  const [showPrivacyDialog, setShowPrivacyDialog] = useState(false);

  return (
    <>
      <div className="bg-[#f8f8f8] rounded-xl overflow-hidden shadow-sm">
        {/* 用户协议 */}
        <div
          className="p-4 flex justify-between items-center border-b active:bg-gray-50 hover:bg-gray-50 transition-colors cursor-pointer"
          onClick={() => setShowAgreementDialog(true)}
        >
          <div className="flex items-center gap-3">
            <FileText className="w-5 h-5 text-gray-500" />
            <span>用户协议</span>
          </div>
          <ChevronRight className="w-5 h-5 text-gray-400" />
        </div>

        {/* 隐私政策 */}
        <div
          className="p-4 flex justify-between items-center active:bg-gray-50 hover:bg-gray-50 transition-colors cursor-pointer"
          onClick={() => setShowPrivacyDialog(true)}
        >
          <div className="flex items-center gap-3">
            <FileText className="w-5 h-5 text-gray-500" />
            <span>隐私政策</span>
          </div>
          <ChevronRight className="w-5 h-5 text-gray-400" />
        </div>
      </div>

      {/* 用户协议对话框 */}
      <Dialog open={showAgreementDialog} onOpenChange={setShowAgreementDialog}>
        <DialogContent className="w-[90%] md:w-[600px] h-[80vh] overflow-hidden p-0">
          <DialogDescription className="sr-only">
            阅读用户服务协议内容
          </DialogDescription>
          <DialogHeader className="px-6 pt-6 pb-4">
            <DialogTitle>用户服务协议</DialogTitle>
          </DialogHeader>
          <div className="overflow-y-auto max-h-[calc(80vh-80px)] px-6 pb-6">
            <UserAgreement />
          </div>
        </DialogContent>
      </Dialog>

      {/* 隐私政策对话框 */}
      <Dialog open={showPrivacyDialog} onOpenChange={setShowPrivacyDialog}>
        <DialogContent className="w-[90%] md:w-[600px] h-[80vh] overflow-hidden p-0">
          <DialogDescription className="sr-only">
            阅读隐私政策内容
          </DialogDescription>
          <DialogHeader className="px-6 pt-6 pb-4">
            <DialogTitle>隐私政策</DialogTitle>
          </DialogHeader>
          <div className="overflow-y-auto max-h-[calc(80vh-80px)] px-6 pb-6">
            <PrivacyAgreement />
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}
